<template>
  <div class="features_items">
    <div v-if="groupSlug ===''">
      <h2 class="title text-center">Products</h2>
      <template v-for="productCategory in products.productGroups[0].productCategories">
        <product-cateogry-item :productCategory="productCategory" :groupSlug="products.productGroups[0].slug" v-bind:key="productCategory.productCategoryId" ></product-cateogry-item>
      </template>
    </div>
    <div v-else>
      <h1>Products</h1>
      <template v-for="productCategory in products.productGroups.filter(g => g.slug === groupSlug)[0].productCategories">
        <product-cateogry-item :productCategory="productCategory" :groupSlug="groupSlug" v-bind:key="productCategory.productCategoryId" ></product-cateogry-item>
      </template>
    </div>
  </div>
</template>

<script>
import ProductCategoryItem from './ProductCategoryItem';

export default {
  name: 'product-categories',
  props: ['groupSlug'],
  created() {
    if (this.products.length === 0) {
      this.$store.dispatch('allProducts');
    }
  },
  computed: {
    products() {
      return this.$store.getters.allProducts;
    },
  },
  components: {
    'product-cateogry-item': ProductCategoryItem,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/products/ProductCategories.vue